import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchS3Settings() {
  try {
    debugger;
    const { data } = yield call(api.get, {
      route: 'AppSettings/s3',
    });
    const s3Settings = data;
    yield put(Actions.setS3Settings({ s3Settings }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_S3_SETTINGS, fetchS3Settings)]);
}
